<template>
  <div class="smartCity">
    <div class="modular">
      <div class="title">
        <!-- <div class="text">
          智慧数字乡村建设，利用现代信息与互联网技术，构建<span>以网络通信为基础,村大数据为支撑</span>的数据处理中心；构筑<span>智慧管理、智慧服务、智慧决策</span>三大应用体系，共建共享、互融互通的数字乡村框架体系，切实提升村级信息化水平。为乡村实现精细化管理、个性化服务奠定坚实基础，完成<span>信息化体系</span>初步建设，预留拓展空间。通过数字化建设<span>提高农村地区治安管理水平</span>，推广使用各类个体感知、环境监测农业物联网设备。建设<span>智能农业生产决策控制</span>体系，结合乡村旅游发展大趋势，发挥数字乡村的引领作用，整合周边资源，实现乡村可持续发展。
        </div> -->
        <div class="name">智慧园区</div>
        <div class="text">“一张图汇聚城市数据，实现智慧管理”</div>
      </div>
      <ul class="ul">
        <li class="li" v-for="(item, index) in list" :key="index">
          <div class="icon">
            <img :src="item.imgUrl" alt="" />
          </div>
          <div class="text">
            <div class="top">{{ item.title }}</div>
            <div class="bottom">{{ item.text }}</div>
          </div>
        </li>
      </ul>
      <!-- <div class="img">
        <img src="../img/village.png" alt="" />
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'smartCity',
  data() {
    return {
      list: [
        {
          imgUrl: require('../img/masonry.png'),
          title: '综合管控平台',
          text: '基于GIS平台对城市管控设备进行一张图统一管理，总揽全局数据'
        },
        {
          imgUrl: require('../img/masonry.png'),
          title: '物联网运维平台',
          text: '基于GIS平台整合城市物联网设备，实现城市物联网设备运营检测与统一管理'
        },
        {
          imgUrl: require('../img/masonry.png'),
          title: '可视化分析平台',
          text: '基于GIS平台，汇聚各部门业务数据，对数据进行可视化分析和集中展'
        }
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.smartCity {
  position: relative;
  background: #efeff4;
  .modular {
    width: 100%;
    height: 1055px;
    background: #efeff4;
    overflow: hidden;
    margin: 0 auto;
    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 110px;
      padding: 0 354px 0 423px;
      .name {
        font-weight: 600;
        font-size: 40px;
      }
      .text {
        margin-top: 30px;
        font-size: 28px;
        font-family: 'PingFang';
        font-weight: 600;
        color: #252525;
      }
    }
    .ul {
      display: flex;
      flex-flow: wrap;
      height: 630px;
      padding: 77px 180px 0 340px;
      .li {
        display: flex;
        height: 250px;
        .icon {
          margin-top: 10px;
          margin-right: 30px;
        }
        .text {
          .top {
            font-size: 30px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 550;
            color: #252525;
          }
          .bottom {
            margin-top: 20px;
            font-size: 22px;
            letter-spacing: 2px;
            line-height: 37px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #252525;
          }
        }
      }
    }
    .img {
      position: absolute;
      top: 630px;
      left: 780px;
      width: 345px;
      height: 345px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
